import { graphql } from "@/graphql/generated/gql";

export const getClimateActionListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetClimateActionListForWorkspace($input: GetClimateActionListForWorkspaceInput!) {
    climateActionListForWorkspace(getClimateActionListForWorkspaceInput: $input) {
      ...ClimateActionFields
    }
  }
`);

export const getClimateActionQueryDocument = graphql(/* GraphQL */ `
  query GetClimateAction($input: GetClimateActionInput!) {
    climateAction(getClimateActionInput: $input) {
      ...ClimateActionFields
    }
  }
`);

export const createClimateActionMutationDocument = graphql(/* GraphQL */ `
  mutation createClimateAction($input: CreateClimateActionInput!) {
    createClimateAction(createClimateActionInput: $input) {
      ...ClimateActionFields
    }
  }
`);

export const updateClimateActionMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateClimateAction($input: UpdateClimateActionInput!) {
    updateClimateAction(updateClimateActionInput: $input) {
      ...ClimateActionFields
    }
  }
`);

export const getSharedClimateActionListForTeamQueryDocument = graphql(/* GraphQL */ `
  query GetSharedClimateActionListForTeam($input: SharedEntityListForTeamInput!) {
    sharedClimateActionListForTeam(input: $input) {
      ...ClimateActionFields
    }
  }
`);

export const deleteClimateActionMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteClimateAction($input: DeleteClimateActionInput!) {
    deleteClimateAction(deleteClimateActionInput: $input) {
      id
      title
      properties
      description
      yearlyCosts
      reductionImpact
      reductionCalculatorTypeId
      workspaceId
      createdAt
      updatedAt
    }
  }
`);
